var map = {
	"./cabbage-tree.jpg": 5385,
	"./crown-fern.jpg": 6357,
	"./fern-home.jpg": 9169,
	"./grass-home.jpg": 6832,
	"./ibiscus.jpg": 1884,
	"./kauri.jpg": 6523,
	"./paradis-bird.jpg": 3416,
	"./pohutukawa-home.jpg": 6607
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1612;